export const USEROTP="USEROTP"
export const USERNAME="USERNAME"

export const USERCART="USERCART"
export const USERTOTAL="USERTOTAL"